import { render, staticRenderFns } from "./ReportsDashboardBillingSponsorships.vue?vue&type=template&id=efda6236&scoped=true&"
import script from "./ReportsDashboardBillingSponsorships.vue?vue&type=script&lang=js&"
export * from "./ReportsDashboardBillingSponsorships.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDashboardBillingSponsorships.vue?vue&type=style&index=0&id=efda6236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda6236",
  null
  
)

export default component.exports